export {
  ThemeProvider,
  useTheme,
  type Theme,
  type ResolvedTheme,
  type ThemeContextType,
  type ThemeProviderProps,
} from '../providers/theme-provider';

export interface ThemeState {
  theme: 'light' | 'dark' | 'system';
  resolvedTheme: 'light' | 'dark';
  setTheme: (theme: 'light' | 'dark' | 'system') => void;
  toggleTheme: () => void;
  systemTheme?: 'light' | 'dark';
}

/**
 * Kept for backward compatibility
 */
export const setupThemeListener = () => {
  return () => {};
};
